import React, { PureComponent } from 'react';
import classNames from 'classnames';

const getDisplayName = c => c.displayName || c.name || 'Component';

const DisplayComponent = WrappedComponent => {
  class Display extends PureComponent {
    render() {
      // Pass cmsAdmin down so that plugins like Placeholder can pass them to CMS plugins.
      // Pass classes down so that children can add to them and set them as the className.
      // eslint-disable-next-line react/prop-types
      const { classes, cmsAdmin, pluginId, ...otherProps } = this.props;

      // Apply CMS markup if we're in the admin.
      return (
        <WrappedComponent
          classes={classNames(classes, {
            'cms-plugin': cmsAdmin,
            [`cms-plugin-${pluginId}`]: cmsAdmin && pluginId
          })}
          {...otherProps}
        />
      );
    }
  }
  Display.displayName = `DisplayComponent(${getDisplayName(WrappedComponent)})`;
  return Display;
};

export default DisplayComponent;
